import Moment from 'moment'
import _ from 'lodash'

const DateUtils = {
	format(date:Date|string, format:string) {
		if (_.isString(date) && !format) {
			// we're formatting current date.
			format = date
			date = new Date()
		}

		return Moment(date).format(format)
	},

	formatDateTime(date:Date|string) {
		return DateUtils.format(date,'YYYY-MM-DD HH:mm:ss')
	},

	formatDate(date:Date|string) {
		return DateUtils.format(date,'YYYY-MM-DD')
	},

	formatTime(date:Date|string) {
		return DateUtils.format(date,'HH:mm:ss')
	},
}

export default DateUtils
